import React from "react";
import styles from "./consumption-chart.module.scss";

const ConsumptionChartSkeleton: React.FC = () => {
	const bars = [60, 45, 30, 50, 70, 65, 55];
	return (
		<div className={styles.skeletonContainer}>
			{bars.map((height, index) => (
				<div
					key={index}
					className={styles.skeletonBar}
					style={{ height: `${height}%` }}
				/>
			))}
		</div>
	);
};

export default ConsumptionChartSkeleton;
